export const Console = window.console;
